// Forviva Global JS — v2.0
(function () {
  'use strict';

  // Mobile nav toggle
  const toggle = document.querySelector('.fv-nav-toggle');
  const nav = document.querySelector('.fv-nav');
  if (toggle && nav) {
    toggle.addEventListener('click', () => {
      const open = nav.classList.toggle('fv-nav--open');
      toggle.setAttribute('aria-expanded', open);
    });
  }

  // Quantity buttons
  document.querySelectorAll('.fv-qty').forEach((widget) => {
    const input = widget.querySelector('.fv-qty__input');
    widget.querySelector('.fv-qty__btn--minus')?.addEventListener('click', () => {
      const v = parseInt(input.value, 10);
      if (v > 1) input.value = v - 1;
    });
    widget.querySelector('.fv-qty__btn--plus')?.addEventListener('click', () => {
      input.value = parseInt(input.value, 10) + 1;
    });
  });

  // Smooth reveal on scroll
  if ('IntersectionObserver' in window) {
    const obs = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting) {
          e.target.classList.add('fv-visible');
          obs.unobserve(e.target);
        }
      });
    }, { threshold: 0.1 });
    document.querySelectorAll('.fv-reveal').forEach((el) => obs.observe(el));
  }
})();
